// Modo oscuro: guarda la elección explícita del usuario en localStorage.
// Si nunca ha elegido, se usa el tema del sistema operativo como punto de partida
// (ver script inline en public/index.html, que aplica esto mismo antes del primer pintado).
const CLAVE_TEMA = "zervicy-tema";

export function obtenerTemaGuardado() {
  try {
    return localStorage.getItem(CLAVE_TEMA);
  } catch {
    return null;
  }
}

export function obtenerTemaPreferidoSistema() {
  return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function obtenerTemaActual() {
  return document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light";
}

export function aplicarTema(tema) {
  document.documentElement.setAttribute("data-theme", tema);
  // Bootstrap 5.3 trae su propio modo oscuro (cards, modales, dropdowns, badges, etc.,
  // que usan variables --bs-* separadas de las nuestras) — se activa con este atributo.
  document.documentElement.setAttribute("data-bs-theme", tema);
  try {
    localStorage.setItem(CLAVE_TEMA, tema);
  } catch {
    // localStorage no disponible (modo privado, etc.) — el tema igual se aplica en esta sesión.
  }
}

export function alternarTema() {
  const nuevoTema = obtenerTemaActual() === "dark" ? "light" : "dark";
  aplicarTema(nuevoTema);
  return nuevoTema;
}
